const ListContractManager = () => import('./ListContractManager.vue')
const DetailContractManager = () => import('./DetailContractManager.vue')
const EditContractManager = () => import('./EditContractManager.vue')
const EditContract = () => import('./EditContract.vue')
const NewContractManager = () => import('./NewContractManager.vue')
const ContractsPage = () => import('./ContractsPage.vue')
const RolesPage = () => import('./RolesPage.vue')
const CreateRole = () => import('./CreateRole.vue')
const EditRole = () => import('./EditRole.vue')
const CreateContract = () => import('./CreateContract.vue')
const TheContainer = () => import('@/containers/TheContainer')
const RouterView = { render: h => h('router-view') }

// Role management routes (under :id/roles)
const rolesSection = {
    path: 'roles',
    component: RouterView,
    meta: {
        breadcrumb: {
            text: 'Roles',
            to: (context) => ({
                name: 'contract_manager.roles',
                params: { id: context.route.params.id }
            })
        }
    },
    children: [
        {
            path: '',
            name: 'contract_manager.roles',
            component: RolesPage,
            meta: {
                // No additional breadcrumb - parent provides it
            },
        },
        {
            path: 'create',
            name: 'contract_manager.role.create',
            component: CreateRole,
            meta: {
                label: 'Create Role',
                breadcrumb: {
                    text: 'Create'
                }
            },
        },
        {
            path: ':role_id/edit',
            name: 'contract_manager.role.edit',
            component: EditRole,
            meta: {
                label: 'Edit Role',
                breadcrumb: {
                    text: (context) => {
                        const role = context.store.getters['contractManager/role']
                        return role ? `Edit: ${role.name}` : 'Edit'
                    }
                }
            },
        },
    ]
}

// Contract creation route (under :id/contract)
const contractSection = {
    path: 'contract',
    component: RouterView,
    meta: {
        breadcrumb: {
            text: 'Contracts',
            to: (context) => ({
                name: 'contract_manager.contracts',
                params: { id: context.route.params.id }
            })
        }
    },
    children: [
        {
            path: 'create',
            name: 'contract_manager.contract.create',
            component: CreateContract,
            meta: {
                label: 'Create Contract',
                breadcrumb: {
                    text: 'Create'
                }
            },
        },
    ]
}

// Contract Manager detail routes (under :id/)
const contractManagerDetailRoutes = [
    {
        path: 'detail',
        name: 'contract_manager.detail',
        component: DetailContractManager,
        meta: {
            label: 'Contract Manager Detail',
            breadcrumb: {
                text: 'Overview'
            }
        },
    },
    {
        path: 'edit',
        name: 'contract_manager.edit',
        component: EditContractManager,
        meta: {
            label: 'Edit Contract Manager',
            breadcrumb: {
                text: 'Edit'
            }
        },
    },
    {
        path: 'contracts',
        name: 'contract_manager.contracts',
        component: ContractsPage,
        meta: {
            label: 'Contracts',
            breadcrumb: {
                text: 'Contracts'
            }
        },
    },
    rolesSection,
    contractSection
]

// Main contract manager routes
const contractManagerRoutes = [
    {
        path: 'list',
        name: 'contract_manager.list',
        component: ListContractManager,
        meta: {
            label: 'List Contract Managers',
            // No breadcrumb needed - parent provides it
        },
    },
    {
        path: 'new',
        name: 'contract_manager.new',
        component: NewContractManager,
        meta: {
            label: 'Create new Contract Manager',
            breadcrumb: {
                text: 'Create New'
            }
        },
    },
    {
        path: ':id',
        component: RouterView,
        meta: {
            breadcrumb: {
                text: (context) => {
                    const cm = context.store.getters['contractManager/contract_manager']
                    // Se il contract manager non è caricato o l'ID non corrisponde
                    if (!cm || cm.id !== parseInt(context.route.params.id)) {
                        // Trigger del caricamento asincrono (non bloccante)
                        context.store.dispatch('contractManager/fetchContractManager', context.route.params.id)
                            .catch(err => console.error('Failed to load contract manager for breadcrumb:', err))
                        return `Contract Manager #${context.route.params.id}`
                    }
                    return cm.name || `Contract Manager #${context.route.params.id}`
                },
                to: (context) => ({
                    name: 'contract_manager.detail',
                    params: { id: context.route.params.id }
                })
            }
        },
        children: contractManagerDetailRoutes
    },
    {
        // Special route with different param structure
        path: ':contract_manager/contract/:id/edit',
        name: 'contract.edit',
        component: EditContract,
        meta: {
            label: 'Edit Contract',
            breadcrumb: (context) => {
                const cm = context.store.getters['contractManager/contract_manager']
                const contract = context.store.getters['contractManager/contract']
                return [
                    { to: { name: 'index' }, text: context.gettext('Dashboard') },
                    { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
                    { 
                        to: { name: 'contract_manager.detail', params: { id: context.route.params.contract_manager } },
                        text: cm ? cm.name : 'Contract Manager'
                    },
                    { 
                        to: { name: 'contract_manager.contracts', params: { id: context.route.params.contract_manager } },
                        text: 'Contracts'
                    },
                    { text: contract ? `Edit: ${contract.name}` : 'Edit Contract' }
                ]
            },
            breadcrumbMode: 'replace'  // This one replaces because it has different param structure
        },
    },
]

// Main export
export default [
    {
        path: '/contract_manager',
        name: 'contract_manager',
        component: TheContainer,
        meta: {
            breadcrumb: {
                to: { name: 'contract_manager.list' },
                text: 'Contract Managers'
            }
        },
        children: contractManagerRoutes
    }
]